import Vue from "vue";
import { datas } from "bri-vtools";
import getHttpPathMap from "@/data/system/httpPathMap.js";
import getImageSrcMap from "@/data/system/imageSrcMap.js";

const {
    appData
} = datas;

// 系统接口地址
Vue.prototype.$getHttpPathMap = getHttpPathMap;

// 系统所有图片的对应路径映射表
Vue.prototype.$imageSrcMap = getImageSrcMap();

// 应用相关的数据
Vue.prototype.$appData = appData;



// WEBPACK FOOTER //
// ./src/data/index.js